import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { fuzzyPoint, type FuzzyPointRequest, type FuzzyPointResponse } from '@generated/search-bff';

/**
 * Fetch fuzzy point information based on the original point provided using the `/api/v1/geocode/fuzzy/point` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/geocoding/getFuzzyPoint Search API Documentation}
 */
export async function getFuzzyPoint(fuzzyPointRequest: FuzzyPointRequest, apiConfig: ApiConfig): Promise<ApiResult<FuzzyPointResponse>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'getFuzzyPoint');
    const data = await fuzzyPoint(fuzzyPointRequest, _apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
